import BaseModule from "~/vuex/modules/base-module";

let Itineraries = {...BaseModule};

Itineraries.state = function () {
    let state = BaseModule.state();

    state.endpoints['all'] = '/api/itinerary-items';

    state.lastDate = null;
    state.sort = {};


    return state;
};

export default Itineraries;
